import { useState, useEffect } from 'react';
import { useUrlParams } from './hooks/useUrlParams';
import { useConfig } from './hooks/useConfig';
import { useSdkLoader } from './hooks/useSdkLoader';
import { useLiveness } from './hooks/useLiveness';
import { useLivenessCallbacks } from './hooks/useLivenessCallbacks';
import { sendMessage } from './utils/messaging';
import {onReportEvent} from "../../cardCapture/utils";
import {SDK_EVENT_KEYS} from "../../../utils/logService";

function DebugResult({ result }) {
    if (!result) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
            fontFamily: 'system-ui, sans-serif'
        }}>
            <h2 style={{ color: result.isAlive ? '#28a745' : '#dc3545', marginBottom: 20 }}>
                {result.isAlive ? '✓ Validación Exitosa' : '✗ Validación Fallida'}
            </h2>
            {result.image && (
                <img
                    src={`data:image/jpeg;base64,${result.image}`}
                    alt="Captura"
                    style={{ maxWidth: 300, borderRadius: 12, marginBottom: 20, border: '2px solid #eee' }}
                />
            )}
            <div style={{ background: '#f5f5f5', padding: 20, borderRadius: 12, maxWidth: 400, width: '100%' }}>
                <p><strong>Transaction:</strong> {result.transactionId}</p>
                <p><strong>Is Alive:</strong> {result.isAlive ? 'Sí' : 'No'}</p>
                <p><strong>Is Fraud:</strong> {result.isFraud ? 'Sí' : 'No'}</p>
            </div>
        </div>
    );
}

export default function LivenessV8() {
    const [finished, setFinished] = useState(false);
    const [result, setResult] = useState(null);
    const params = useUrlParams();
    const { config, success, loading: configLoading } = useConfig(params.clientId);
    const { loaded: sdkLoaded, error: sdkError } = useSdkLoader(config?.sdkUrl);

    useEffect(() => {
        onReportEvent(SDK_EVENT_KEYS.InitServiceLiveness).catch()
        /*if (params.emitReadyCam === 'true') {
            sendMessage(params.platform, params.isMovil, 'ado-cam-ready', false);
        }*/
    }, []);

    const { handleComplete, handleError, handleClose } = useLivenessCallbacks({
        platform: params.platform,
        isMovil: params.isMovil,
        transactionId: params.transactionId,
        urlServiceLiveness: params.urlServiceLiveness,
        onFinish: () => setFinished(true),
        onResult: params.debug ? setResult : null
    });

    const { startLiveness } = useLiveness({
        config,
        params,
        callbacks: {
            onComplete: handleComplete,
            onError: handleError,
            onClose: handleClose
        }
    });

    useEffect(() => {
        if (!configLoading && !success) {
            handleError({ message: 'No existe configuración', code: 'SDK_LOAD_ERROR' });
        }
    }, [configLoading, success]);
    useEffect(() => {
        if (sdkLoaded && !configLoading && !finished && params.transactionId && params.urlServiceLiveness) {
            startLiveness();
        }
    }, [sdkLoaded, configLoading, finished, params.transactionId, params.urlServiceLiveness, startLiveness]);

    useEffect(() => {
        if (sdkError) {
            handleError({ message: sdkError, code: 'SDK_LOAD_ERROR' });
        }
    }, [sdkError, handleError]);

    if (params.debug && result) {
        return <DebugResult result={result} />;
    }

    return null;
}
